import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeInsert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeInsert"><Path d="M15 2H17V4H22V20H17V22H15V2Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H13V20H2ZM10.9144 12.0002L7.00015 8.08594L5.58594 9.50015L8.08594 12.0002L5.58594 14.5002L7.00015 15.9144L10.9144 12.0002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeInsert;
